'use client'

import { useContext } from 'react'
import { Navigate } from 'react-router-dom'

import { ShowAtBreakpoint } from '@marketplace-web/shared/breakpoints'
import { UiState } from '@marketplace-web/shared/ui-state'
import { CONVERSATION_URL } from '@marketplace-web/messaging/conversation-messaging-data'
import { ConversationListContext } from '@marketplace-web/messaging/conversation-providers-feature'

import ConversationListEmptyState from '../ConversationListEmptyState'

const RedirectToFirstConversation = () => {
  const { conversations, uiState } = useContext(ConversationListContext)

  if (!conversations.length) {
    if (uiState === UiState.Success)
      return (
        <ShowAtBreakpoint breakpoint="desktops">
          <ConversationListEmptyState />
        </ShowAtBreakpoint>
      )

    return null
  }

  return <Navigate to={CONVERSATION_URL(conversations[0]!.id)} replace />
}

export default RedirectToFirstConversation
